export const lessonStatus = Object.freeze({
  CANCELLED: 'cancelled',
  NORMAL: 'normal',
  ABSENT: 'absent',
  SUBSTITUTE: 'substitute',
  TO_BE_DELETED: 'to_be_deleted',
  WILL_BE_UPDATED: 'will_be_updated',
});
